<div class="animated fadeIn">

<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             <h4 class="box-title">Help Document </h4>
             
              <br/>
              <div style="border: 2px solid #dee2e6; padding: 5px; " id="editCont"> 
              	<div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Document Title
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="docTitle" [(ngModel)]="docTitle" id="docTitle" class="form-control-sm form-control" required="" />
                                    </div>
                                </div>
                                 <div class="row form-group">
                                    <div class="col col-md-3"><label for="file-multiple-input" class=" form-control-label">Document</label></div>
                                    <div class="col-12 col-md-9"><input type="file" id="docFile" [(ngModel)]="dFile" name="docFile"  class="form-control-file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ></div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"></div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-actions form-group">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="uploadDoc()" >Upload</button>
                                             
                                        </div>

                                    </div>

                                </div>
                </div>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
                                            <thead>
                                                <tr role="row">
                                                    <th>Document Title</th>
                                                    <th>File Name</th>
                                                    <th>Uploaded On</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody> 
                                            <tr role="row" class="odd" *ngFor="let fdata of fileData">
                                                <td class="sorting_1">Admin User Manual</td>
                                                <!-- <td>{{fdata.docFile}}</td> -->
                                                <td>PDF_User_Manual_-_Online_MIS_Admin.pdf</td>
                                                <td>{{fdata.createDate| date:'dd-MM-yyyy HH:mm:ss'}}</td>
                                                
                                                
                                                <td>{{fdata.status?"Active":"Inactive"}}</td>
                                              <td>
                                               <a href="{{downLoadPath}}others/PDF_User_Manual_-_Online_MIS_Admin.pdf" class="btn" ><i class="fa fa-download"></i></a>
                                               <a  style="margin-left: 5px;" (click)="deleteDoc(fdata.id)" class="btn"><i class="fa fa-trash"></i></a>
                                               </td>
                                            </tr> 
                                            
                                            
                                        </tbody>
                                        </table>
            </div>
        </div>
       


</div>
</div><!-- .animated -->
<div class="loaderbox" *ngIf="loaderVisibility">
    <div class="load">
        <img src="assets/images/loading.gif" alt="">
    </div>
</div>
